<template>
  <w-setting-sliding-popup ref="slidingPopup" :title="title" width="1200px" @open="open" @close="close">
    <div slot="content">
      <div v-show="!infoShowFlag && !initPasswordShowFlag && !changePasswordShowFlag">
        <el-steps :active="activeStep" finish-status="success">
          <el-step v-for="(step, index) in stepTitles" :key="index" :title="step"></el-step>
        </el-steps>
        <w-user-info-form
          v-show="activeStep === 1"
          :popup-type="popupType"
          :selected-user-info="selectedUserInfo"
          @click-manager-type-info="chagneInfoShowFlag('managerType')"
          @init-password="changeInitPasswordShowFlag"
          @change-password="changeChangePasswordShowFlag"
          ref="userInfoForm"
        />
        <w-device-auth-setting
          v-show="activeStep === 2"
          :managerType="managerType"
          :show-flag="activeStep === 2"
          :active="activeStep === 2 && !loadedData"
          :flow-analysis-auth-flag="flowAnalysisAuthFlag"
          @click-device-auth-info="chagneInfoShowFlag('deviceAuth')"
          ref="deviceAuthSetting"
          :checked-obj-list="checkedObjList"
        />
      </div>
      <w-init-password v-if="initPasswordShowFlag" @click-back-button="changeInitPasswordShowFlag" :selected-user-info="selectedUserInfo"></w-init-password>
      <w-change-password v-if="changePasswordShowFlag" @click-back-button="changeChangePasswordShowFlag" :selected-user-info="userInfoForChangePassword" :policy="policy"></w-change-password>
      <div v-show="infoShowFlag">
        <w-manager-type-info v-show="infoType === 'managerType'" @click-back-button="chagneInfoShowFlag"></w-manager-type-info>
        <w-device-auth-info v-show="infoType === 'deviceAuth'" @click-back-button="chagneInfoShowFlag"></w-device-auth-info>
      </div>
    </div>
    <el-row slot="footer" v-show="!infoShowFlag && !initPasswordShowFlag && !changePasswordShowFlag" type="flex" justify="space-between">
      <div>
        <el-button size="large" v-show="activeStep === 2" @click="prevStep">이전</el-button>
      </div>
      <div>
        <el-button size="large" type="primary" @click="saveUserInfo">완료</el-button>
        <el-button size="large" v-show="activeStep === 1" type="solid" @click="nextStep">다음</el-button>
        <el-button size="large" @click="closePopup">취소</el-button>
      </div>
    </el-row>
  </w-setting-sliding-popup>
</template>

<script>
import { isNil, assign, cloneDeep, isEqual, isEmpty } from 'lodash';
import { EMPTY_TEXT } from '@/utils/string';
import loginAPI from '@/api/login';
import UserSettingAPI from '@/api/settings/user/user-setting';
import msgUtil from '@/utils/message';
import { createEncryptTargetData, getRsaEncrypt } from '@/utils/rsa-encrypt';
import WUserInfoForm from '../components/UserInfoForm';
import WDeviceAuthSetting from '../components/DeviceAuthSetting';
import WManagerTypeInfo from '../components/ManagerTypeInfo';
import WDeviceAuthInfo from '../components/DeviceAuthInfo';
import WInitPassword from '../components/InitPassword';
import WChangePassword from '../components/ChangePassword';

export default {
  name: 'WUserPopup',
  components: {
    WUserInfoForm,
    WDeviceAuthSetting,
    WManagerTypeInfo,
    WDeviceAuthInfo,
    WInitPassword,
    WChangePassword,
  },
  props: {
    popupType: String,
    selectedUserId: {
      type: String,
      default: '',
    },
  },
  computed: {
    title() {
      if (this.popupType === 'add') {
        return '사용자 추가';
      }
      const selectedUserInfo = this.selectedUserInfo;
      const grade = isEmpty(selectedUserInfo.grade) ? EMPTY_TEXT : selectedUserInfo.grade;
      return `[${grade}] ${selectedUserInfo.managerName} 정보 수정`;
    },
  },
  watch: {
    selectedUserInfo: {
      handler(object) {
        if (!isNil(object.managerId)) {
          if (isEqual(this.popupType, 'update')) {
            if (!isEmpty(this.selectedUserInfo.managerPhoto)) {
              const photo = this.selectedUserInfo.managerPhoto;
              this.selectedUserInfo.managerPhoto = `data:${photo.headers['Content-Type'][0]} ;base64, ${photo.body}`;
            } else {
              this.selectedUserInfo.managerPhoto = '';
            }
            this.userInfoForChangePassword = this.selectedUserInfo;
          }
        }
      },
      immediate: true,
    },
    activeStep: {
      handler(value) {
        const selectedUserInfo = this.selectedUserInfo;
        if (value === 2 && selectedUserInfo.managerType !== 'ADMIN' && !isNil(selectedUserInfo.managerId) && this.popupType === 'update' && !this.loadedData) {
          UserSettingAPI.getDeviceAuthInfo(this.selectedUserInfo.managerId).then((response) => {
            const result = response.data.data;
            if (!isNil(result)) {
              const checkedObjList = result.checkedObjList;
              this.checkedObjList = checkedObjList;
              this.loadedData = true;
              this.flowAnalysisAuthFlag = result.flowAnalysisAuthFlag;
            }
          });
        }
      },
    },
  },
  data() {
    return {
      loadedData: false,
      activeStep: 1,
      infoShowFlag: false,
      infoType: 'managerType',
      userInfoFormData: null,
      managerType: null,
      initPasswordShowFlag: false,
      changePasswordShowFlag: false,
      checkedObjList: [],
      flowAnalysisAuthFlag: 'Y',
      stepTitles: ['사용자 정보 입력', '모니터링 권한 부여'],
      policy: {},
      userInfoForChangePassword: {},
      selectedUserInfo: {
        grade: null,
        managerName: null,
      },
    };
  },
  methods: {
    open() {
      this.$nextTick(() => {
        this.$refs.userInfoForm.$refs.userInfoForm.clearValidate('managerType');
        if (isEqual(this.popupType, 'update')) {
          this.loadData();
        }
      });
    },
    close() {
      this.loadedData = false;
      this.activeStep = 1;
      this.infoShowFlag = false;
      this.initPasswordShowFlag = false;
      this.changePasswordShowFlag = false;
      this.$refs.userInfoForm.resetFields();
      this.checkedObjList = [];
      this.$refs.deviceAuthSetting.initData();
      this.selectedUserInfo = {
        grade: null,
        managerName: null,
      };
    },
    closePopup() {
      this.$refs.slidingPopup.visible = false;
    },
    loadData() {
      UserSettingAPI.getUserInfo({
        managerId: this.selectedUserId,
      })
        .then((response) => {
          if (response.data.success) {
            this.selectedUserInfo = cloneDeep(response.data.data);
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.VIEW, '사용자 정보', false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData(msgUtil.VIEW, '사용자 정보', false));
        });
    },
    chagneInfoShowFlag(infoType) {
      this.infoType = infoType;
      this.infoShowFlag = !this.infoShowFlag;
    },
    nextStep() {
      this.$refs.userInfoForm.checkValidation().then((response) => {
        if (response) {
          this.userInfoFormData = this.$refs.userInfoForm.getUserInfoFormData();
          this.managerType = this.userInfoFormData.managerType;
          this.activeStep = 2;
        }
      });
    },
    prevStep() {
      this.activeStep = 1;
    },
    /**
     * 사용자 목록을 수정 또는 저장한다.
     * @author yelim
     */
    saveUserInfo() {
      this.userInfoFormData = this.$refs.userInfoForm.getUserInfoFormData();
      this.managerType = this.userInfoFormData.managerType;
      this.$refs.userInfoForm.checkValidation().then((res) => {
        if (res) {
          const fileData = this.$refs.userInfoForm.file.fileInfo;
          const formParams = new FormData();
          if (!isEqual(this.managerType, 'ADMIN')) {
            const deviceAuthSettingData = this.$refs.deviceAuthSetting.getDeviceAuthSettingData();
            formParams.append('objIds', deviceAuthSettingData.objIds);
            formParams.append('flowAnalysisAuthFlag', deviceAuthSettingData.flowAnalysisAuthFlag);
          }
          // 사진 파일을 저장하기 위해 formParams에 append하여 파라미터를 전달한다.
          if (!isNil(fileData)) {
            formParams.append('file', fileData);
          }

          const userInfoFormData = this.userInfoFormData;
          formParams.append('managerId', this.isCheckValue(userInfoFormData.managerId));
          formParams.append('managerName', this.isCheckValue(userInfoFormData.managerName));
          formParams.append('managerType', this.isCheckValue(userInfoFormData.managerType));
          formParams.append('association', this.isCheckValue(userInfoFormData.association));
          formParams.append('department', this.isCheckValue(userInfoFormData.department));
          formParams.append('lockStatus', this.isCheckValue(userInfoFormData.lockStatus));
          formParams.append('grade', this.isCheckValue(userInfoFormData.grade));
          formParams.append('empno', this.isCheckValue(userInfoFormData.empno));
          formParams.append('mobileNumber', this.isCheckValue(userInfoFormData.mobileNumber));
          formParams.append('telNumber', this.isCheckValue(userInfoFormData.telNumber));
          formParams.append('email', this.isCheckValue(userInfoFormData.email));
          formParams.append('accessAllowIp', this.isCheckValue(userInfoFormData.accessAllowIp));

          if (isEqual(this.popupType, 'add')) {
            const target = '사용자';
            const action = msgUtil.action.ADD;
            const encryptTargetData = createEncryptTargetData({ password: this.isCheckValue(userInfoFormData.password) }, ['password']);
            getRsaEncrypt(encryptTargetData)
              .then((encryptData) => {
                formParams.append('password', encryptData.password);
                UserSettingAPI.insertUserInfo(formParams)
                  .then((response) => {
                    if (response.data.success) {
                      this.$message(msgUtil.getResultMsgData(action, target, true));
                      this.$emit('reload-data');
                      this.closePopup();
                    } else {
                      this.$message(msgUtil.getCustomResultMsgData(response.data.message, false));
                    }
                  })
                  .catch(() => {
                    this.$message(msgUtil.getResultMsgData(action, target, false));
                  });
              })
              .catch((e) => {
                this.$message(msgUtil.getResultMsgData(action, target, false));
                throw new Error(e);
              });
          } else {
            const target = '사용자 정보';
            const action = msgUtil.action.SAVE;
            UserSettingAPI.updateUserInfo(formParams)
              .then((response) => {
                if (response.data.success) {
                  this.$message(msgUtil.getResultMsgData(action, target, true));
                  if (this.userInfoFormData.managerId === this.$store.getters.userInfo.managerId) {
                    this.reloadUserInfoStore();
                  }
                  this.$emit('reload-data');
                  this.closePopup();
                } else {
                  this.$message(msgUtil.getCustomResultMsgData(response.data.message, false));
                }
              })
              .catch(() => {
                this.$message(msgUtil.getResultMsgData(action, target, false));
              });
          }
        }
      });
    },
    /**
     * [reloadUserInfo userInfo 리로드 한다.]
     * @author {Yang}
     */
    reloadUserInfoStore() {
      loginAPI.checkLogin().then((response) => {
        const result = response.data;
        if (!isEmpty(result) && result.success === true && !isEmpty(result.data)) {
          const data = response.data.data;
          this.$store.dispatch('setUserInfo', data.userInfo);
          this.$store.dispatch('setRoles', data.roles);
        }
      });
    },
    changeInitPasswordShowFlag() {
      this.initPasswordShowFlag = !this.initPasswordShowFlag;
    },
    changeChangePasswordShowFlag(policy, userInfo) {
      this.policy = policy;
      this.userInfoForChangePassword = userInfo;
      this.changePasswordShowFlag = !this.changePasswordShowFlag;
    },
    /**
     * [getGradeString grade 값이 없을경우 EMPTY_TEXT를 리턴]
     * @author {Yang}
     */
    getGradeString(value) {
      return isNil(value) || isEmpty(value) ? EMPTY_TEXT : value;
    },
    isCheckValue(value) {
      return isNil(value) ? '' : value;
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/settings/basic/UserAndAuthManagement/UserSettings/popup/UserPopup.vue